class BuyLinks {

    constructor() {
        this.bindLoadEvents();
    }

    bindLoadEvents() {
        this.bindBuyLinks();
    }

    bindBuyLinks() {

        $('.buy-link-stockist').on('change', function () {
            let productId = $(this).attr('data-product-id');
            let selectedStockistText = $(this).find('option:selected').text();
            let buyNowLink = $('.buy-now-link[data-product-id='+productId+']');
            let buyNowLinkUrl = $(this).val();

            if(buyNowLinkUrl == 0){
                buyNowLink.attr('href', '');
                buyNowLink.removeAttr('data-stockist');
                buyNowLink.addClass('disabled');
            } else {
                buyNowLink.attr('href', buyNowLinkUrl);
                buyNowLink.attr('data-stockist', selectedStockistText);
                buyNowLink.removeClass('disabled');
            }
        });

        $('.buy-now-link').on('click', function (e) {
            if (!$(this).attr('href')) {
                e.preventDefault();
            }
        });

    }

}

export default BuyLinks;